import { Avatar, Container, Grid, Text, VStack } from "@chakra-ui/react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import bg from "../../../assets/course.webp";
import Layout from "../../../components/student/Layout/layout";
import { getAllSectionsRequest } from "../../../modules/students-modules/sections/Actions";

const SectionsList = () => {
  const sections = useSelector((state) => state.sections.sections);
  const isLoading = useSelector((state) => state.sections.isLoading);
  const { id, type } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    if (id) dispatch(getAllSectionsRequest(id));
  }, [id]);
  return (
    <Layout color="main_1" bg="white" isLoading={isLoading}>
      <Container maxW="container.xl" h="100%" my="150px" mb="165px" w="100%">
        <VStack spacing={8} h="100%" w="100%" alignItems="flex-start">
          {/* <Heading as="h3" color="main_1" textAlign="center" w="100%">
            Videos
          </Heading> */}

          <Grid
            templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(4, 1fr)" }}
            gap={6}
            w="100%"
          >
            {sections?.map((section, idx) => {
              return (
                <Link to={`/section/${section?.id}/chapters/${type}`} key={idx}>
                  <VStack
                    bg="#ededed"
                    borderRadius="8px"
                    alignItems="center"
                    justifyContent="center"
                    p="10px"
                    spacing="20px"
                    w="100%"
                    cursor="pointer"
                    h="200px"
                    role="group"
                    _hover={{
                      color: "white",
                      bg: "main_1",
                      transition: "500ms ease-in-out",
                    }}
                  >
                    <Avatar
                      name={section?.name}
                      src={bg}
                      borderRadius="8px"
                      size="md"
                      background="transparent"
                      _groupHover={{
                        transform: "scale(1.5)",
                        transition: "500ms ease-in-out",
                      }}
                    />

                    <Text
                      fontWeight="700"
                      fontSize="16px"
                      w="250px"
                      textAlign="center"
                    >
                      {section?.name}
                    </Text>
                    <Text
                      fontWeight="700"
                      fontSize="12px"
                      color="gray.500"
                      w="250px"
                      textAlign="center"
                    >
                      {section?.chapters?.length} Lessons
                    </Text>
                  </VStack>
                </Link>
              );
            })}
          </Grid>
        </VStack>
      </Container>
    </Layout>
  );
};

export default SectionsList;
